import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
import { Box, Stack, Typography } from '@lyearn/ui';

interface Error404Props {
  className?: string;
}

const Error404 = (props: Error404Props) => {
  const { className = 'justify-center items-center inset-0 fixed' } = props;
  const { t } = useTranslation(['Common']);

  return (
    <Box className={cn('flex', className)}>
      <Stack
        alignItems="center"
        className="xs: mx-auto w-4/5 items-center xs:flex-col-reverse"
        justifyContent="around">
        <Stack
          alignItems="start"
          className=" xs:mt-50 xs:items-center xs:text-center"
          direction="col"
          gapY={32}>
          <Typography variant="heading-m">{t('Common:404class')}</Typography>
        </Stack>
      </Stack>
    </Box>
  );
};

export default Error404;
